export type ActivityType =
  | 'EXECUTION'
  | 'MESSAGE'
  | 'PROCESS';

export type AllType =
  | 'ACTIVITY'
  | 'BUNDLE'
  | 'BUNDLE_REPOSITORY'
  | 'CONNECTOR'
  | 'CUSTOM_OBJECT'
  | 'DASHBOARD'
  | 'DEVOLUTIONS_CONFIG'
  | 'EGRESS_POLICY'
  | 'EXECUTION'
  | 'FILE'
  | 'FLOW'
  | 'IDENTITY'
  | 'LDAP_CONFIG'
  | 'MCP_USER_TOOL'
  | 'MESSAGE'
  | 'OBJECT_TEMPLATE'
  | 'ORGANIZATION'
  | 'PLUGIN'
  | 'PROCESS'
  | 'PROJECT'
  | 'PYTHON_MODULE'
  | 'RECORD'
  | 'RESOURCE'
  | 'ROLE'
  | 'SCHEDULE'
  | 'SCHEDULER'
  | 'SCHEMA'
  | 'SECRET'
  | 'SETTING'
  | 'SYNC_CONFIG'
  | 'TAG'
  | 'USER'
  | 'VAULT_CONFIG'
  | 'WEBHOOK'
  | 'WORKSPACE'
  | 'WRAPPER'
  | 'ZONE';

export type BundleItemType =
  | 'BUNDLE_REPOSITORY'
  | 'CONNECTOR'
  | 'CUSTOM_OBJECT'
  | 'DASHBOARD'
  | 'DEVOLUTIONS_CONFIG'
  | 'EGRESS_POLICY'
  | 'EXECUTION'
  | 'FILE'
  | 'FLOW'
  | 'LDAP_CONFIG'
  | 'MCP_USER_TOOL'
  | 'MESSAGE'
  | 'OBJECT_TEMPLATE'
  | 'PLUGIN'
  | 'PYTHON_MODULE'
  | 'ROLE'
  | 'SCHEDULE'
  | 'SCHEDULER'
  | 'SCHEMA'
  | 'SECRET'
  | 'SETTING'
  | 'SYNC_CONFIG'
  | 'TAG'
  | 'VAULT_CONFIG'
  | 'WEBHOOK'
  | 'WRAPPER'
  | 'ZONE';

export type ConnectorType =
  | 'AWS'
  | 'AZURE'
  | 'AZUREAI'
  | 'CLAUDE'
  | 'FTP'
  | 'GIT'
  | 'GOOGLE'
  | 'HTTP'
  | 'IMAP'
  | 'JSONRPC'
  | 'K8S'
  | 'LDAP'
  | 'MYSQL'
  | 'OPENAI'
  | 'OVH'
  | 'PS'
  | 'REDIS'
  | 'REST'
  | 'SCP'
  | 'SFTP'
  | 'SMB'
  | 'SMTP'
  | 'SOAP'
  | 'SQLMSSQL'
  | 'SQLORACLE'
  | 'SQLPG'
  | 'SSH'
  | 'VAULT'
  | 'WEBDAV'
  | 'XMLRPC';

export type ContainerType =
  | 'BUNDLE'
  | 'PROJECT'
  | 'WORKSPACE';

export type CustomObjectProvisioningState =
  | 'CREATE_FAILED'
  | 'CREATING'
  | 'DELETED'
  | 'DELETE_FAILED'
  | 'DELETING'
  | 'READY'
  | 'UPDATE_FAILED'
  | 'UPDATING';

export type ExecutionStatus =
  | 'AT_ENGINE'
  | 'ENDED_CANCELLED'
  | 'ENDED_ERROR'
  | 'ENDED_SUCCESS'
  | 'PAUSED'
  | 'SCHEDULED'
  | 'WAITING_DEPENDENCY'
  | 'WAITING_ENGINE'
  | 'WAITING_LOCK'
  | 'WAITING_RECORD'
  | 'WAITING_RESPONSE';

export type ExecutionType =
  | 'CONNECTION'
  | 'FLOW'
  | 'SCHEDULE'
  | 'SCRIPT'
  | 'WRAPPER';

export type IdentityType =
  | 'EXECUTION'
  | 'LDAP_CONFIG'
  | 'SCHEDULE'
  | 'SYNC_CONFIG'
  | 'USER'
  | 'WEBHOOK'
  | 'WORKSPACE';

export type MessageType =
  | 'ERROR'
  | 'INFO'
  | 'POPUP'
  | 'SUCCESS'
  | 'WARNING';

export type MetaType =
  | 'ACTIVITY'
  | 'IDENTITY'
  | 'RECORD'
  | 'RESOURCE';

export type NonBundleItemType =
  | 'BUNDLE'
  | 'ORGANIZATION'
  | 'PROCESS'
  | 'PROJECT'
  | 'USER'
  | 'WORKSPACE';

export type NonProjectItemType =
  | 'BUNDLE'
  | 'BUNDLE_REPOSITORY'
  | 'LDAP_CONFIG'
  | 'ORGANIZATION'
  | 'PROCESS'
  | 'PROJECT'
  | 'ROLE'
  | 'USER'
  | 'WORKSPACE'
  | 'ZONE';

export type NonReadOnlyType =
  | 'EXECUTION'
  | 'LDAP_CONFIG'
  | 'MESSAGE'
  | 'ORGANIZATION'
  | 'PROCESS'
  | 'USER'
  | 'WORKSPACE';

export type NonWorkspaceItemType =
  | 'CONNECTOR'
  | 'CUSTOM_OBJECT'
  | 'DASHBOARD'
  | 'DEVOLUTIONS_CONFIG'
  | 'EGRESS_POLICY'
  | 'EXECUTION'
  | 'FILE'
  | 'FLOW'
  | 'MCP_USER_TOOL'
  | 'MESSAGE'
  | 'OBJECT_TEMPLATE'
  | 'PLUGIN'
  | 'PYTHON_MODULE'
  | 'SCHEDULE'
  | 'SCHEDULER'
  | 'SCHEMA'
  | 'SECRET'
  | 'SETTING'
  | 'SYNC_CONFIG'
  | 'TAG'
  | 'VAULT_CONFIG'
  | 'WEBHOOK'
  | 'WRAPPER';

export type ObjectTemplateAttributeDataType =
  | 'ALLOWED_VALUES'
  | 'BOOLEAN'
  | 'BYTES'
  | 'DATE'
  | 'DATETIME'
  | 'INCOMING_REFERENCE'
  | 'JSON'
  | 'MARKDOWN'
  | 'NUMBER'
  | 'OBJECT_TEMPLATE_REFERENCE'
  | 'RECORD_REFERENCE'
  | 'STRING'
  | 'TEXT'
  | 'TIME';

export type PaymentType =
  | 'INVOICE';

export type PermissionOperation =
  | 'CREATE'
  | 'DELETE'
  | 'LIST'
  | 'READ'
  | 'UPDATE';

export type PluginActionType =
  | 'LIST'
  | 'RECORD';

export type ProjectItemType =
  | 'CONNECTOR'
  | 'CUSTOM_OBJECT'
  | 'DASHBOARD'
  | 'DEVOLUTIONS_CONFIG'
  | 'EGRESS_POLICY'
  | 'EXECUTION'
  | 'FILE'
  | 'FLOW'
  | 'MCP_USER_TOOL'
  | 'MESSAGE'
  | 'OBJECT_TEMPLATE'
  | 'PLUGIN'
  | 'PYTHON_MODULE'
  | 'SCHEDULE'
  | 'SCHEDULER'
  | 'SCHEMA'
  | 'SECRET'
  | 'SETTING'
  | 'SYNC_CONFIG'
  | 'TAG'
  | 'VAULT_CONFIG'
  | 'WEBHOOK'
  | 'WRAPPER';

export type ReadOnlyType =
  | 'BUNDLE'
  | 'BUNDLE_REPOSITORY'
  | 'CONNECTOR'
  | 'CUSTOM_OBJECT'
  | 'DASHBOARD'
  | 'DEVOLUTIONS_CONFIG'
  | 'EGRESS_POLICY'
  | 'FILE'
  | 'FLOW'
  | 'MCP_USER_TOOL'
  | 'OBJECT_TEMPLATE'
  | 'PLUGIN'
  | 'PROJECT'
  | 'PYTHON_MODULE'
  | 'ROLE'
  | 'SCHEDULE'
  | 'SCHEDULER'
  | 'SCHEMA'
  | 'SECRET'
  | 'SETTING'
  | 'SYNC_CONFIG'
  | 'TAG'
  | 'VAULT_CONFIG'
  | 'WEBHOOK'
  | 'WRAPPER'
  | 'ZONE';

export type RecordLogLevel =
  | 'ERROR'
  | 'INFO'
  | 'WARNING';

export type RecordType =
  | 'BUNDLE'
  | 'BUNDLE_REPOSITORY'
  | 'CONNECTOR'
  | 'CUSTOM_OBJECT'
  | 'DASHBOARD'
  | 'DEVOLUTIONS_CONFIG'
  | 'EGRESS_POLICY'
  | 'EXECUTION'
  | 'FILE'
  | 'FLOW'
  | 'LDAP_CONFIG'
  | 'MCP_USER_TOOL'
  | 'MESSAGE'
  | 'OBJECT_TEMPLATE'
  | 'ORGANIZATION'
  | 'PLUGIN'
  | 'PROCESS'
  | 'PROJECT'
  | 'PYTHON_MODULE'
  | 'ROLE'
  | 'SCHEDULE'
  | 'SCHEDULER'
  | 'SCHEMA'
  | 'SECRET'
  | 'SETTING'
  | 'SYNC_CONFIG'
  | 'TAG'
  | 'USER'
  | 'VAULT_CONFIG'
  | 'WEBHOOK'
  | 'WORKSPACE'
  | 'WRAPPER'
  | 'ZONE';

export type ResourceType =
  | 'BUNDLE'
  | 'BUNDLE_REPOSITORY'
  | 'CONNECTOR'
  | 'CUSTOM_OBJECT'
  | 'DASHBOARD'
  | 'DEVOLUTIONS_CONFIG'
  | 'EGRESS_POLICY'
  | 'FILE'
  | 'FLOW'
  | 'LDAP_CONFIG'
  | 'MCP_USER_TOOL'
  | 'OBJECT_TEMPLATE'
  | 'ORGANIZATION'
  | 'PLUGIN'
  | 'PROJECT'
  | 'PYTHON_MODULE'
  | 'ROLE'
  | 'SCHEDULE'
  | 'SCHEDULER'
  | 'SCHEMA'
  | 'SECRET'
  | 'SETTING'
  | 'SYNC_CONFIG'
  | 'TAG'
  | 'USER'
  | 'VAULT_CONFIG'
  | 'WEBHOOK'
  | 'WORKSPACE'
  | 'WRAPPER'
  | 'ZONE';

export type ReturnWhen =
  | 'ALL_ENDED'
  | 'ALL_SUCCEEDED'
  | 'FIRST_ENDED';

export type SavepointRetention =
  | 'ALL'
  | 'LAST';

export type SubrecordType =
  | 'CONTAINER_DASHBOARD'
  | 'DEPENDENCY'
  | 'DEPENDENCY_EXECUTION'
  | 'EXECUTION_DUMP'
  | 'GIT_LOG'
  | 'IDENTITY_ROLE'
  | 'OBJECT_TEMPLATE_ATTRIBUTE'
  | 'PLUGIN_ACTION'
  | 'RECORD_COMMENT'
  | 'RECORD_COMMENT_READ'
  | 'RECORD_COMMENT_WATERMARK'
  | 'RECORD_LOG'
  | 'RECORD_LOG_RECORD'
  | 'RECORD_METADATA'
  | 'RECORD_TAG'
  | 'RECORD_USER'
  | 'RECORD_ZONE'
  | 'RESOURCE_WRAPPER'
  | 'ROLE_PERMISSION'
  | 'USER_GIT_PUBLIC_KEY'
  | 'WORKSPACE_CONFIGURATION'
  | 'WORKSPACE_SYNC';

export type WorkspaceItemType =
  | 'BUNDLE'
  | 'BUNDLE_REPOSITORY'
  | 'LDAP_CONFIG'
  | 'ORGANIZATION'
  | 'PROCESS'
  | 'PROJECT'
  | 'ROLE'
  | 'USER'
  | 'WORKSPACE'
  | 'ZONE';

export type Execution_Status_ =
  | 'AT_ENGINE'
  | 'ENDED_CANCELLED'
  | 'ENDED_ERROR'
  | 'ENDED_SUCCESS'
  | 'PAUSED'
  | 'SCHEDULED'
  | 'WAITING_DEPENDENCY'
  | 'WAITING_ENGINE'
  | 'WAITING_LOCK'
  | 'WAITING_RECORD'
  | 'WAITING_RESPONSE';

export type Time_Interval =
  | 'all'
  | 'day'
  | 'hour'
  | 'minute'
  | 'month'
  | 'quarter'
  | 'week'
  | 'year';

export const ACTIVITY_TYPE = ['EXECUTION', 'MESSAGE', 'PROCESS'] as const;
export const ALL_TYPE = ['ACTIVITY', 'BUNDLE', 'BUNDLE_REPOSITORY', 'CONNECTOR', 'CUSTOM_OBJECT', 'DASHBOARD', 'DEVOLUTIONS_CONFIG', 'EGRESS_POLICY', 'EXECUTION', 'FILE', 'FLOW', 'IDENTITY', 'LDAP_CONFIG', 'MCP_USER_TOOL', 'MESSAGE', 'OBJECT_TEMPLATE', 'ORGANIZATION', 'PLUGIN', 'PROCESS', 'PROJECT', 'PYTHON_MODULE', 'RECORD', 'RESOURCE', 'ROLE', 'SCHEDULE', 'SCHEDULER', 'SCHEMA', 'SECRET', 'SETTING', 'SYNC_CONFIG', 'TAG', 'USER', 'VAULT_CONFIG', 'WEBHOOK', 'WORKSPACE', 'WRAPPER', 'ZONE'] as const;
export const BUNDLE_ITEM_TYPE = ['BUNDLE_REPOSITORY', 'CONNECTOR', 'CUSTOM_OBJECT', 'DASHBOARD', 'DEVOLUTIONS_CONFIG', 'EGRESS_POLICY', 'EXECUTION', 'FILE', 'FLOW', 'LDAP_CONFIG', 'MCP_USER_TOOL', 'MESSAGE', 'OBJECT_TEMPLATE', 'PLUGIN', 'PYTHON_MODULE', 'ROLE', 'SCHEDULE', 'SCHEDULER', 'SCHEMA', 'SECRET', 'SETTING', 'SYNC_CONFIG', 'TAG', 'VAULT_CONFIG', 'WEBHOOK', 'WRAPPER', 'ZONE'] as const;
export const CONNECTOR_TYPE = ['AWS', 'AZURE', 'AZUREAI', 'CLAUDE', 'FTP', 'GIT', 'GOOGLE', 'HTTP', 'IMAP', 'JSONRPC', 'K8S', 'LDAP', 'MYSQL', 'OPENAI', 'OVH', 'PS', 'REDIS', 'REST', 'SCP', 'SFTP', 'SMB', 'SMTP', 'SOAP', 'SQLMSSQL', 'SQLORACLE', 'SQLPG', 'SSH', 'VAULT', 'WEBDAV', 'XMLRPC'] as const;
export const CONTAINER_TYPE = ['BUNDLE', 'PROJECT', 'WORKSPACE'] as const;
export const CUSTOM_OBJECT_PROVISIONING_STATE = ['CREATE_FAILED', 'CREATING', 'DELETED', 'DELETE_FAILED', 'DELETING', 'READY', 'UPDATE_FAILED', 'UPDATING'] as const;
export const EXECUTION_STATUS = ['AT_ENGINE', 'ENDED_CANCELLED', 'ENDED_ERROR', 'ENDED_SUCCESS', 'PAUSED', 'SCHEDULED', 'WAITING_DEPENDENCY', 'WAITING_ENGINE', 'WAITING_LOCK', 'WAITING_RECORD', 'WAITING_RESPONSE'] as const;
export const EXECUTION_TYPE = ['CONNECTION', 'FLOW', 'SCHEDULE', 'SCRIPT', 'WRAPPER'] as const;
export const IDENTITY_TYPE = ['EXECUTION', 'LDAP_CONFIG', 'SCHEDULE', 'SYNC_CONFIG', 'USER', 'WEBHOOK', 'WORKSPACE'] as const;
export const MESSAGE_TYPE = ['ERROR', 'INFO', 'POPUP', 'SUCCESS', 'WARNING'] as const;
export const META_TYPE = ['ACTIVITY', 'IDENTITY', 'RECORD', 'RESOURCE'] as const;
export const NON_BUNDLE_ITEM_TYPE = ['BUNDLE', 'ORGANIZATION', 'PROCESS', 'PROJECT', 'USER', 'WORKSPACE'] as const;
export const NON_PROJECT_ITEM_TYPE = ['BUNDLE', 'BUNDLE_REPOSITORY', 'LDAP_CONFIG', 'ORGANIZATION', 'PROCESS', 'PROJECT', 'ROLE', 'USER', 'WORKSPACE', 'ZONE'] as const;
export const NON_READ_ONLY_TYPE = ['EXECUTION', 'LDAP_CONFIG', 'MESSAGE', 'ORGANIZATION', 'PROCESS', 'USER', 'WORKSPACE'] as const;
export const NON_WORKSPACE_ITEM_TYPE = ['CONNECTOR', 'CUSTOM_OBJECT', 'DASHBOARD', 'DEVOLUTIONS_CONFIG', 'EGRESS_POLICY', 'EXECUTION', 'FILE', 'FLOW', 'MCP_USER_TOOL', 'MESSAGE', 'OBJECT_TEMPLATE', 'PLUGIN', 'PYTHON_MODULE', 'SCHEDULE', 'SCHEDULER', 'SCHEMA', 'SECRET', 'SETTING', 'SYNC_CONFIG', 'TAG', 'VAULT_CONFIG', 'WEBHOOK', 'WRAPPER'] as const;
export const OBJECT_TEMPLATE_ATTRIBUTE_DATA_TYPE = ['ALLOWED_VALUES', 'BOOLEAN', 'BYTES', 'DATE', 'DATETIME', 'INCOMING_REFERENCE', 'JSON', 'MARKDOWN', 'NUMBER', 'OBJECT_TEMPLATE_REFERENCE', 'RECORD_REFERENCE', 'STRING', 'TEXT', 'TIME'] as const;
export const PAYMENT_TYPE = ['INVOICE'] as const;
export const PERMISSION_OPERATION = ['CREATE', 'DELETE', 'LIST', 'READ', 'UPDATE'] as const;
export const PLUGIN_ACTION_TYPE = ['LIST', 'RECORD'] as const;
export const PROJECT_ITEM_TYPE = ['CONNECTOR', 'CUSTOM_OBJECT', 'DASHBOARD', 'DEVOLUTIONS_CONFIG', 'EGRESS_POLICY', 'EXECUTION', 'FILE', 'FLOW', 'MCP_USER_TOOL', 'MESSAGE', 'OBJECT_TEMPLATE', 'PLUGIN', 'PYTHON_MODULE', 'SCHEDULE', 'SCHEDULER', 'SCHEMA', 'SECRET', 'SETTING', 'SYNC_CONFIG', 'TAG', 'VAULT_CONFIG', 'WEBHOOK', 'WRAPPER'] as const;
export const READ_ONLY_TYPE = ['BUNDLE', 'BUNDLE_REPOSITORY', 'CONNECTOR', 'CUSTOM_OBJECT', 'DASHBOARD', 'DEVOLUTIONS_CONFIG', 'EGRESS_POLICY', 'FILE', 'FLOW', 'MCP_USER_TOOL', 'OBJECT_TEMPLATE', 'PLUGIN', 'PROJECT', 'PYTHON_MODULE', 'ROLE', 'SCHEDULE', 'SCHEDULER', 'SCHEMA', 'SECRET', 'SETTING', 'SYNC_CONFIG', 'TAG', 'VAULT_CONFIG', 'WEBHOOK', 'WRAPPER', 'ZONE'] as const;
export const RECORD_LOG_LEVEL = ['ERROR', 'INFO', 'WARNING'] as const;
export const RECORD_TYPE = ['BUNDLE', 'BUNDLE_REPOSITORY', 'CONNECTOR', 'CUSTOM_OBJECT', 'DASHBOARD', 'DEVOLUTIONS_CONFIG', 'EGRESS_POLICY', 'EXECUTION', 'FILE', 'FLOW', 'LDAP_CONFIG', 'MCP_USER_TOOL', 'MESSAGE', 'OBJECT_TEMPLATE', 'ORGANIZATION', 'PLUGIN', 'PROCESS', 'PROJECT', 'PYTHON_MODULE', 'ROLE', 'SCHEDULE', 'SCHEDULER', 'SCHEMA', 'SECRET', 'SETTING', 'SYNC_CONFIG', 'TAG', 'USER', 'VAULT_CONFIG', 'WEBHOOK', 'WORKSPACE', 'WRAPPER', 'ZONE'] as const;
export const RESOURCE_TYPE = ['BUNDLE', 'BUNDLE_REPOSITORY', 'CONNECTOR', 'CUSTOM_OBJECT', 'DASHBOARD', 'DEVOLUTIONS_CONFIG', 'EGRESS_POLICY', 'FILE', 'FLOW', 'LDAP_CONFIG', 'MCP_USER_TOOL', 'OBJECT_TEMPLATE', 'ORGANIZATION', 'PLUGIN', 'PROJECT', 'PYTHON_MODULE', 'ROLE', 'SCHEDULE', 'SCHEDULER', 'SCHEMA', 'SECRET', 'SETTING', 'SYNC_CONFIG', 'TAG', 'USER', 'VAULT_CONFIG', 'WEBHOOK', 'WORKSPACE', 'WRAPPER', 'ZONE'] as const;
export const RETURN_WHEN = ['ALL_ENDED', 'ALL_SUCCEEDED', 'FIRST_ENDED'] as const;
export const SAVEPOINT_RETENTION = ['ALL', 'LAST'] as const;
export const SUBRECORD_TYPE = ['CONTAINER_DASHBOARD', 'DEPENDENCY', 'DEPENDENCY_EXECUTION', 'EXECUTION_DUMP', 'GIT_LOG', 'IDENTITY_ROLE', 'OBJECT_TEMPLATE_ATTRIBUTE', 'PLUGIN_ACTION', 'RECORD_COMMENT', 'RECORD_COMMENT_READ', 'RECORD_COMMENT_WATERMARK', 'RECORD_LOG', 'RECORD_LOG_RECORD', 'RECORD_METADATA', 'RECORD_TAG', 'RECORD_USER', 'RECORD_ZONE', 'RESOURCE_WRAPPER', 'ROLE_PERMISSION', 'USER_GIT_PUBLIC_KEY', 'WORKSPACE_CONFIGURATION', 'WORKSPACE_SYNC'] as const;
export const WORKSPACE_ITEM_TYPE = ['BUNDLE', 'BUNDLE_REPOSITORY', 'LDAP_CONFIG', 'ORGANIZATION', 'PROCESS', 'PROJECT', 'ROLE', 'USER', 'WORKSPACE', 'ZONE'] as const;
export const XECUTION_STATUS_ = ['AT_ENGINE', 'ENDED_CANCELLED', 'ENDED_ERROR', 'ENDED_SUCCESS', 'PAUSED', 'SCHEDULED', 'WAITING_DEPENDENCY', 'WAITING_ENGINE', 'WAITING_LOCK', 'WAITING_RECORD', 'WAITING_RESPONSE'] as const;
export const IME_INTERVAL = ['all', 'day', 'hour', 'minute', 'month', 'quarter', 'week', 'year'] as const;